import { ShippingTemplate } from '@client/components/shipping/shipping-template.tsx';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useContext } from 'react';
import { CartContext } from '@r/context/cart-context.ts';
import CartSummary from '@client/components/cart/cart-summary.tsx';
import { Button } from '@ui/button.tsx';
import { useStepper } from '@client/pages/cart/cart.tsx';
import { useTranslation } from 'react-i18next';

export const FormSchema = z.object({
  phone: z.string()
});

const Shipping = () => {
  const { t } = useTranslation();
  const stepper = useStepper();
  const { cartWithTotals: cart } = useContext(CartContext);

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      phone: ''
    }
  });

  const handleSubmit = (data: z.infer<typeof FormSchema>) => {
    return data;
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-5">
      <div className="flex flex-col">
        <ShippingTemplate cart={cart} form={form} />

        <div className="pt-5">
          <Button variant="outline" rounded="full" onClick={() => stepper.prev()}>
            {t('common.back')}
          </Button>
        </div>
      </div>

      <div className="relative">
        <div className="flex flex-col gap-y-4">
          <CartSummary context="shipping" cart={cart} onSubmit={form.handleSubmit(handleSubmit)} />
        </div>
      </div>
    </div>
  );
};

export { Shipping };
